import * as React from "react";

export const MethylationMethylationKeyContent = () => (
  <>
    <g id="Key">
      <rect width={1424} height={212} fill="white" />
      <g id="Container">
        <g id="key-item - Gene">
          <rect x={40.5} y={28.5} width={386.748} height={183} stroke="#818181" />
          <text
            id="gene-label"
            fill="#1A1A1A"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Bold"
            fontSize={12}
            letterSpacing="2.8px"
          >
            <tspan x={52.4383} y={48.4}>
              GENETICS
            </tspan>
          </text>
          <g id="Container_2">
            <g id="Container_3">
              <g id="Container_4">
                <g id="Component 2">
                  <g id="gene-lozenge">
                    <path
                      d="M56 58.3896H72C73.9941 58.3896 75.6104 60.0059 75.6104 62V78C75.6104 79.9941 73.9941 81.6104 72 81.6104H56C54.0059 81.6104 52.3896 79.9941 52.3896 78V62C52.3896 60.0059 54.0059 58.3896 56 58.3896Z"
                      fill="#E5E5E5"
                    />
                    <path
                      d="M56 58.3896H72C73.9941 58.3896 75.6104 60.0059 75.6104 62V78C75.6104 79.9941 73.9941 81.6104 72 81.6104H56C54.0059 81.6104 52.3896 79.9941 52.3896 78V62C52.3896 60.0059 54.0059 58.3896 56 58.3896Z"
                      stroke="#1A1A1A"
                      strokeWidth={0.778643}
                    />
                  </g>
                </g>
                <text
                  id="Description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.0723} y={74.767}>
                    Not included in panel
                  </tspan>
                </text>
              </g>
              <g id="Container_5">
                <g id="Component 2_2">
                  <g id="gene-lozenge_2">
                    <path
                      d="M52 90C52 87.7909 53.7909 86 56 86H72C74.2091 86 76 87.7909 76 90V106C76 108.209 74.2091 110 72 110H56C53.7909 110 52 108.209 52 106V90Z"
                      fill="#CCBAFF"
                    />
                  </g>
                </g>
                <text
                  id="Description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2559} y={102.767}>
                    No read
                  </tspan>
                </text>
              </g>
              <g id="Container_6">
                <g id="Component 2_3">
                  <g id="snp-indicator">
                    <path
                      id="Polygon 3"
                      d="M63.3387 120.372C63.6326 119.876 64.3674 119.876 64.6613 120.372L70.8966 130.885C71.1905 131.381 70.8231 132 70.2352 132H57.7648C57.1769 132 56.8095 131.381 57.1034 130.885L63.3387 120.372Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.1738} y={130.767}>
                    Increased activity
                  </tspan>
                </text>
              </g>
              <g id="Container_7">
                <g id="Component 2_4">
                  <g id="snp-indicator_2">
                    <path
                      id="Polygon 3_2"
                      d="M64.6613 159.628C64.3674 160.124 63.6326 160.124 63.3387 159.628L57.1034 149.115C56.8095 148.619 57.1769 148 57.7648 148L70.2352 148C70.8231 148 71.1905 148.619 70.8966 149.115L64.6613 159.628Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_4"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2285} y={158.767}>
                    Decreased activity
                  </tspan>
                </text>
              </g>
            </g>
            <g id="Container_8">
              <g id="Container_9">
                <g id="Component 2_5">
                  <g id="gene-lozenge_3">
                    <path
                      d="M237 62C237 59.7909 238.791 58 241 58H257C259.209 58 261 59.7909 261 62V78C261 80.2091 259.209 82 257 82H241C238.791 82 237 80.2091 237 78V62Z"
                      fill="#00BF86"
                    />
                  </g>
                </g>
                <text
                  id="Risk description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.288} y={74.767}>
                    0 risk alleles
                  </tspan>
                </text>
              </g>
              <g id="Container_10">
                <g id="Component 2_6">
                  <g id="gene-lozenge_4">
                    <path
                      d="M237 90C237 87.7909 238.791 86 241 86H257C259.209 86 261 87.7909 261 90V106C261 108.209 259.209 110 257 110H241C238.791 110 237 108.209 237 106V90Z"
                      fill="#FF905F"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.271} y={102.767}>
                    1 risk allele
                  </tspan>
                </text>
              </g>
              <g id="Container_11">
                <g id="Component 2_7">
                  <g id="gene-lozenge_5">
                    <path
                      d="M237 118C237 115.791 238.791 114 241 114H257C259.209 114 261 115.791 261 118V134C261 136.209 259.209 138 257 138H241C238.791 138 237 136.209 237 134V118Z"
                      fill="#FF5D6D"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.006} y={130.767}>
                    2 risk alleles
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="key-item - Not included">
            <g id="Icon">
              <path
                id="*"
                d="M63.7483 186.79V189.209L59.8178 189.08L62.0638 192.319L59.861 193.615L57.8741 190.116L55.8873 193.615L53.6845 192.319L55.9305 189.08L52 189.209L52 186.79L55.9305 186.92L53.6845 183.681L55.8873 182.385L57.8741 185.883L59.861 182.385L62.0638 183.681L59.8178 186.92L63.7483 186.79Z"
                fill="black"
              />
            </g>
            <text
              id="Explanation"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={73.748} y={192.086}>
                Limited / insufficient evidence for interpretation in this context
              </tspan>
            </text>
          </g>
        </g>
        <g id="Container_12">
          <g id="key-item - vitamin">
            <g id="Vitamin-Mineral">
              <g id="diamond">
                <path
                  id="Vector"
                  d="M481.126 28.9375L505.126 52.9375L481.126 76.9375L457.126 52.9375L481.126 28.9375Z"
                  stroke="#1A1A1A"
                />
              </g>
            </g>
            <text
              id="Vitamin description"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={517.218} y={57.767}>
                Vitamin / Mineral
              </tspan>
            </text>
          </g>
          <g id="key-item - co factor">
            <g id="Cofactor">
              <g id="diamond_2">
                <g id="Vector_2">
                  <mask id="path-21-inside-1_18291_211496" fill="white">
                    <path d="M675.748 32L696.748 42.1818V63.8182L675.748 74L654.748 63.8182V42.1818L675.748 32Z" />
                  </mask>
                  <path
                    d="M675.748 32L696.748 42.1818V63.8182L675.748 74L654.748 63.8182V42.1818L675.748 32Z"
                    stroke="#1A1A1A"
                    strokeWidth={2}
                    mask="url(#path-21-inside-1_18291_211496)"
                  />
                </g>
              </g>
            </g>
            <text
              id="Cofactor_2"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={706.749} y={57.767}>
                Cofactor
              </tspan>
            </text>
          </g>
          <g id="key-item - affect">
            <g id="lines">
              <path
                id="Vector_3"
                d="M792.448 52.3C792.062 52.3 791.748 52.6134 791.748 53C791.748 53.3866 792.062 53.7 792.448 53.7V53V52.3ZM846.748 53L839.748 48.9585V57.0415L846.748 53ZM794.388 53.7C794.774 53.7 795.088 53.3866 795.088 53C795.088 52.6134 794.774 52.3 794.388 52.3V53V53.7ZM798.266 52.3C797.88 52.3 797.566 52.6134 797.566 53C797.566 53.3866 797.88 53.7 798.266 53.7V53V52.3ZM802.145 53.7C802.531 53.7 802.845 53.3866 802.845 53C802.845 52.6134 802.531 52.3 802.145 52.3V53V53.7ZM806.023 52.3C805.637 52.3 805.323 52.6134 805.323 53C805.323 53.3866 805.637 53.7 806.023 53.7V53V52.3ZM809.902 53.7C810.288 53.7 810.602 53.3866 810.602 53C810.602 52.6134 810.288 52.3 809.902 52.3V53V53.7ZM813.78 52.3C813.394 52.3 813.08 52.6134 813.08 53C813.08 53.3866 813.394 53.7 813.78 53.7V53V52.3ZM817.659 53.7C818.046 53.7 818.359 53.3866 818.359 53C818.359 52.6134 818.046 52.3 817.659 52.3V53V53.7ZM821.538 52.3C821.151 52.3 820.838 52.6134 820.838 53C820.838 53.3866 821.151 53.7 821.538 53.7V53V52.3ZM825.416 53.7C825.803 53.7 826.116 53.3866 826.116 53C826.116 52.6134 825.803 52.3 825.416 52.3V53V53.7ZM829.295 52.3C828.908 52.3 828.595 52.6134 828.595 53C828.595 53.3866 828.908 53.7 829.295 53.7V53V52.3ZM833.173 53.7C833.56 53.7 833.873 53.3866 833.873 53C833.873 52.6134 833.56 52.3 833.173 52.3V53V53.7ZM837.052 52.3C836.665 52.3 836.352 52.6134 836.352 53C836.352 53.3866 836.665 53.7 837.052 53.7V53V52.3ZM840.93 53.7C841.317 53.7 841.63 53.3866 841.63 53C841.63 52.6134 841.317 52.3 840.93 52.3V53V53.7ZM844.809 52.3C844.422 52.3 844.109 52.6134 844.109 53C844.109 53.3866 844.422 53.7 844.809 53.7V53V52.3ZM792.448 53V53.7H794.388V53V52.3H792.448V53ZM798.266 53V53.7H802.145V53V52.3H798.266V53ZM806.023 53V53.7H809.902V53V52.3H806.023V53ZM813.78 53V53.7L817.659 53.7V53V52.3L813.78 52.3V53ZM821.538 53V53.7H825.416V53V52.3H821.538V53ZM829.295 53V53.7H833.173V53V52.3H829.295V53ZM837.052 53V53.7H840.93V53V52.3H837.052V53Z"
                fill="#E44C4B"
              />
            </g>
            <text
              id="Affect"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={856.785} y={57.767}>
                Negative impact
              </tspan>
            </text>
          </g>
          <g id="key-item - Affect 3">
            <g id="Frame 472">
              <rect
                x={993.448}
                y={41.7}
                width={46.6}
                height={22.6}
                stroke="#5220DD"
                strokeWidth={1.4}
                strokeDasharray="2.8 2.8"
              />
            </g>
            <text
              id="Affect_2"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={1051.21} y={57.767}>
                Outcome
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </g>
  </>
);

const SvgMethylationMethylationKey = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1424}
    height={212}
    viewBox="0 0 1424 212"
    fill="none"
    {...props}
  >
    <MethylationMethylationKeyContent />
  </svg>
);

export default SvgMethylationMethylationKey;
